import FileDropTarget from './FileDropTarget';

export default FileDropTarget;
